import React from 'react';
import { X, CheckCircle, Clock, Edit3, XCircle } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const STEP_ICONS = {
  submitted: Clock,
  edited: Edit3,
  approved: CheckCircle,
  rejected: XCircle,
};

const STEP_COLORS = {
  submitted: '#f59e0b',
  edited: '#3b82f6',
  approved: '#16a34a',
  rejected: '#DC143C',
};

const AuditTrailPanel = ({ row, onClose }) => {
  if (!row) return null;
  const history = row?.auditHistory || [];

  return (
    <div className="fixed inset-0 z-50 flex justify-end" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
      <div
        className="h-full w-full max-w-md bg-white shadow-2xl flex flex-col overflow-hidden"
        style={{ borderLeft: '1px solid #e8ddd0' }}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: '#e8ddd0', backgroundColor: '#fffbeb' }}>
          <div>
            <h3 className="font-bold text-base" style={{ color: '#1f2937' }}>Audit Trail</h3>
            <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>
              {row?.millName} · {row?.grade} · {row?.season}
            </p>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-amber-100 transition">
            <X size={16} style={{ color: '#6b7280' }} />
          </button>
        </div>

        {/* Summary row */}
        <div className="px-5 py-3 border-b flex gap-4 text-xs" style={{ borderColor: '#e8ddd0', backgroundColor: '#f8f1e9' }}>
          <div><span className="font-medium" style={{ color: '#6b7280' }}>Rate Excl GST:</span> <span className="font-bold" style={{ color: '#1f2937' }}>₹{row?.rateExcl?.toLocaleString('en-IN')}</span></div>
          <div><span className="font-medium" style={{ color: '#6b7280' }}>Qty:</span> <span className="font-bold" style={{ color: '#1f2937' }}>{row?.qty} MT</span></div>
          <div><span className="font-medium" style={{ color: '#6b7280' }}>Status:</span> <span className="font-bold capitalize" style={{ color: '#1f2937' }}>{row?.status}</span></div>
        </div>

        {/* Timeline */}
        <div className="flex-1 overflow-y-auto px-5 py-5">
          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-4 top-0 bottom-0 w-0.5" style={{ backgroundColor: '#e8ddd0' }} />
            <div className="space-y-6">
              {history?.map((step, idx) => {
                const Icon = STEP_ICONS?.[step?.type] || Clock;
                const color = STEP_COLORS?.[step?.type] || '#6b7280';
                return (
                  <div key={idx} className="relative flex gap-4">
                    <div
                      className="relative z-10 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 border-2 border-white"
                      style={{ backgroundColor: color + '20', boxShadow: `0 0 0 2px ${color}` }}
                    >
                      <Icon size={14} style={{ color }} />
                    </div>
                    <div className="flex-1 pt-0.5">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-sm font-semibold capitalize" style={{ color: '#1f2937' }}>{step?.type}</span>
                        <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ backgroundColor: color + '15', color }}>
                          {step?.actor}
                        </span>
                      </div>
                      <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>{step?.timestamp}</p>
                      {step?.note && (
                        <div className="mt-1.5 px-3 py-2 rounded-lg text-xs" style={{ backgroundColor: '#f8f1e9', color: '#4b5563', borderLeft: `3px solid ${color}` }}>
                          {step?.note}
                        </div>
                      )}
                      {step?.changes && (
                        <div className="mt-1.5 text-xs" style={{ color: '#4b5563' }}>
                          {step?.changes?.map((c, ci) => (
                            <div key={ci} className="flex gap-1 items-center">
                              <span className="font-medium">{c?.field}:</span>
                              <span className="line-through" style={{ color: '#9ca3af' }}>{c?.from}</span>
                              <span>→</span>
                              <span className="font-semibold" style={{ color: '#16a34a' }}>{c?.to}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditTrailPanel;
